module.exports = __webpack_public_path__ + "static/media/giraffe-4312090_1280.87992b28.jpg";